// extracted by mini-css-extract-plugin
export default {"Option":"Option_Option"};